/**
 * Which public site this app is running on:
 * - `uz`: app.examing.uz, the Uzbek product (learner marketplace, coins, plans, Telegram/SMS).
 * - `io`: app.examing.io, the global B2B product: organizations, groups and join-by-code only.
 *
 * Both sites are the same build and talk to the same API; the hostname decides.
 * The API enforces the rules that matter (no marketplace publishing, io payment
 * methods); hiding things here is UX only.
 */
export type Site = 'uz' | 'io';

const IO_HOST = /(^|\.)examing\.io$/i;

export function siteFromHostname(hostname: string | undefined, override?: string): Site {
  // Local dev: REACT_APP_SITE=io previews the io mode on localhost.
  if (override === 'io' || override === 'uz') return override;
  return hostname && IO_HOST.test(hostname) ? 'io' : 'uz';
}

export function getSite(): Site {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : undefined;
  const isLocal = !hostname || hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.localhost');
  return siteFromHostname(hostname, isLocal ? process.env.REACT_APP_SITE : undefined);
}

/** Fixed for the lifetime of the page: the hostname never changes without a reload. */
export const SITE: Site = getSite();
export const IS_IO = SITE === 'io';

/** The brand mark for this site: volt on examing.uz, blueberry on examing.io. */
export const LOGO_SRC = IS_IO ? '/logo-io.svg' : '/logo.svg';
